var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAz = function SvgIconAz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24 12c0-1.468-.264-2.874-.746-4.174L12 7.304.746 7.826A12 12 0 0 0 0 12c0 1.468.264 2.874.746 4.174L12 16.696l11.254-.522c.482-1.3.746-2.706.746-4.174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12 24c5.16 0 9.559-3.257 11.254-7.827H.747C2.443 20.743 6.841 24 12.001 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M.747 7.825h22.507C21.56 3.255 17.16 0 12.001 0 6.84-.001 2.443 3.256.747 7.825"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.26 15.391a3.391 3.391 0 1 1 1.614-6.375 4.174 4.174 0 1 0 0 5.967c-.48.26-1.03.408-1.613.408"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.87 9.65.449 1.264 1.21-.575-.575 1.21 1.263.45-1.263.449.575 1.21-1.21-.575-.45 1.264-.449-1.264-1.21.576.575-1.211-1.264-.45 1.264-.448-.576-1.212 1.211.576z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconAz;